"use strict";
import lottie from "lottie-web";

var elements = document.querySelectorAll(".special02__sec");
document.addEventListener("scroll", function () {
  Array.prototype.forEach.call(elements, function (element, index) {
    var windowHeight = window.document.documentElement.clientHeight;

    var scrollTop =
      document.documentElement.scrollTop || document.body.scrollTop;

    var rect = element.getBoundingClientRect();
    var offset = rect.top + scrollTop;

    var scrollHeight = offset - windowHeight;

    // 画面の1/4を超えたら、classを追加
    if (scrollTop > scrollHeight + windowHeight / 4) {
      element.classList.add("exit");
      exitAnimation(element.dataset.number);
    }
  });
});

var funcIcon = {
  icon01: function () {
    icon01.play();
  },
  icon02: function () {
    icon02.play();
  },
  icon03: function () {
    icon03.play();
  },
  icon04: function () {
    icon04.play();
  },
  icon05: function () {
    icon05.play();
  },
  icon06: function () {
    icon06.play();
  },
};
function exitAnimation(number) {
  setTimeout(function () {
    var func = funcIcon[number];
    func();
  }, 300);
}

/**
 * lottie設定
 * ★要確認★ Object.assign使えるか(windows10 chromeはOK)
 */
// icon - デフォルト
var defaultOption = {
  renderer: "svg",
  loop: false,
  autoplay: false,
};

// icon - 給料・残業
var addOption01 = {
  container: document.querySelector(".special02__icon--01"),
  path: "../img/workersrealvoice/icon_sec_01.json",
};
var icon01 = lottie.loadAnimation(
  Object.assign({}, defaultOption, addOption01)
);

// icon - 休暇
var addOption02 = {
  container: document.querySelector(".special02__icon--02"),
  path: "../img/workersrealvoice/icon_sec_02.json",
};
var icon02 = lottie.loadAnimation(
  Object.assign({}, defaultOption, addOption02)
);

// icon - 業務内容
var addOption03 = {
  container: document.querySelector(".special02__icon--03"),
  path: "../img/workersrealvoice/icon_sec_03.json",
};
var icon03 = lottie.loadAnimation(
  Object.assign({}, defaultOption, addOption03)
);

// icon - 社風
var addOption04 = {
  container: document.querySelector(".special02__icon--04"),
  path: "../img/workersrealvoice/icon_sec_04.json",
};
var icon04 = lottie.loadAnimation(
  Object.assign({}, defaultOption, addOption04)
);

// icon - 人
var addOption05 = {
  container: document.querySelector(".special02__icon--05"),
  path: "../img/workersrealvoice/icon_sec_05.json",
};
var icon05 = lottie.loadAnimation(
  Object.assign({}, defaultOption, addOption05)
);

// icon - その他
var addOption06 = {
  container: document.querySelector(".special02__icon--06"),
  path: "../img/workersrealvoice/icon_sec_06.json",
};
var icon06 = lottie.loadAnimation(
  Object.assign({}, defaultOption, addOption06)
);
